// extracted by mini-css-extract-plugin
export default {"arrowIcon":"ao8hpN","arrowIconOpened":"bo8hpN"};